import { c as _c } from "react/compiler-runtime";
import useSuspenseQuery from 'commons/useSuspenseQuery';
import { GET_BLOG_HOME_PAGE } from 'mocks/queries';
import useIsRefreshCache from 'hooks/useIsRefreshCache';
const useBlogHomePage = t0 => {
  const $ = _c(9);
  const {
    blogUrl
  } = t0;
  const isRefreshCache = useIsRefreshCache();
  let t1;
  if ($[0] !== blogUrl) {
    t1 = {
      blogUrl
    };
    $[0] = blogUrl;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = isRefreshCache ? "network-only" : "cache-first";
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = {
      variables: t1,
      fetchPolicy: t2
    };
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    loading,
    data,
    error
  } = useSuspenseQuery(GET_BLOG_HOME_PAGE, t3);
  const t4 = data?.getBlogHomePage;
  const t5 = error || data?.getBlogHomePage?.errors?.[0]?.message;
  let t6;
  if ($[5] !== loading || $[6] !== t4 || $[7] !== t5) {
    t6 = {
      loading,
      data: t4,
      error: t5
    };
    $[5] = loading;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};
export default useBlogHomePage;